export const allowSubmission = (challenge = {}, isUpdating) => {
    if (!challenge.name)
        return {
            submit: false,
            error: 'Please Enter a Title for your Challenge',
        };
    if (!challenge.mission)
        return {
            submit: false,
            error: 'Please enter challenge Mission Detail',
        };
    if (isUpdating) {
        if (!challenge.worldwide && !challenge.location.lat) {
            return {
                submit: false,
                error:
                    'Challenge should either be world wide or a location should be selected.',
            };
        }
    }
    if (
        !challenge.litterQuantityTarget ||
        challenge.litterQuantityTarget < 10 ||
        challenge.litterQuantityTarget > 1000000000
    )
        return {
            submit: false,
            error:
                'Please add a number between 10 to 1000000000 to your Litter Goal',
        };
    if (!challenge.startDate)
        return {
            submit: false,
            error: 'Please select a Start Date for your Challenge',
        };
    if (!challenge.expiresAt)
        return {
            submit: false,
            error: 'Please select an End Date of your Challenge',
        };
    if (challenge.challengeType === 'global' && !challenge.banner)
        return {
            submit: false,
            error: 'You must upload an image for the Challenge',
        };
    if (challenge.challengeType === 'connected' && !challenge.parentChallengeId)
        return {
            submit: false,
            error: 'You need to Select a Parent Challenge to connect to',
        };
    return {
        submit: true,
        error: null,
    };
};

export const transformChallengeForAPI = (challenge = {}) => {
    let transformedChallenge = {
        ...challenge,
        shapeType: 'CIRCLE',
        isPrivate: challenge.isPrivate == 'private' ? true : false,
        startDate: challenge.startDate
            ? new Date(challenge.startDate).valueOf()
            : new Date().valueOf(),
        expiresAt: new Date(challenge.expiresAt).valueOf(),
        worldwide:
            challenge.challengeType == 'local' ? false : challenge.worldwide,
    };
    if (challenge.worldwide)
        transformedChallenge = {
            ...transformedChallenge,
            location: { lat: 0, long: 0 },
            circleRadius: 1,
            locality: null,
        };
    if (transformedChallenge.parentChallengeId)
        transformedChallenge.parentChallengeId =
            transformedChallenge.parentChallengeId.id;
    return transformedChallenge;
};
